<template>
  <div v-if="loading">
    Wird geladen...
  </div>
  <div v-else-if="overlappingBookings.length > 0" class="alert alert-danger">
    <h4>Überlappende Buchungen gefunden!</h4>
    <ul>
      <li v-for="booking in visibleBookings" :key="booking.booking_id">
        Raum: {{ booking.room_name }}, <span v-html="formatBookingTime(booking.booking_start, booking.booking_end)"></span>
          <span>{{ booking.booking_comment }} != {{ booking.overlap_comment }}</span>
      </li>
    </ul>
    <button 
      v-if="overlappingBookings.length > 5 && !showAll" 
      @click="showAll = true" 
      class="btn btn-link"
      type="button"
    >
      Alle Anzeigen ({{ overlappingBookings.length }} gesamt)
    </button>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export default {
  data() {
    return {
      loading: true,
      overlappingBookings: [],
      showAll: false,
    };
  },
  computed: {
    visibleBookings() {
      if (this.showAll || this.overlappingBookings.length <= 5) {
        return this.overlappingBookings;
      }
      return this.overlappingBookings.slice(0, 5);
    },
  },
  mounted() {
    this.fetchOverlappingBookings();
  },
  methods: {
    fetchOverlappingBookings() {
      axios.get('/admin/conference-rooms/overlapping-bookings')
        .then(response => {
          this.overlappingBookings = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          console.error('Fehler beim Abrufen überlappender Buchungen:', error);
          this.loading = false;
        });
    },
    formatBookingTime(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      const formattedStartDate = format(startDate, 'dd.MM.yyyy', { locale: de });
      const formattedStartTime = format(startDate, 'HH:mm', { locale: de });
      const formattedEndTime = format(endDate, 'HH:mm', { locale: de });

      if (startDate.toDateString() === endDate.toDateString()) {
        return `<b>${formattedStartDate}</b> ${formattedStartTime} - ${formattedEndTime} Uhr`;
      } else {
        const formattedEndDate = format(endDate, 'dd.MM.yyyy', { locale: de });
        return `<b>${formattedStartDate}</b> ${formattedStartTime} - <b>${formattedEndDate}</b> ${formattedEndTime} Uhr`;
      }
    },
  },
};
</script>

<style scoped>
.alert-danger {
  color: #a94442;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;
  text-decoration: none;
}

.btn-link {
  font-weight: normal;
  color: #337ab7;
  border-radius: 0;
  background-color: transparent;
  border-color: transparent;
}

.btn-link:hover,
.btn-link:focus {
  color: #23527c;
  text-decoration: underline;
  background-color: transparent;
}
</style>